import { Injectable } from '@angular/core'
import { ActiveCartService, getCartIdByUserId } from '@spartacus/cart/base/core'
import { OCC_CART_ID_CURRENT, OCC_USER_ID_ANONYMOUS, UserIdService, WindowRef } from '@spartacus/core'
import { Observable, combineLatest, of } from 'rxjs'
import { filter, take, withLatestFrom } from 'rxjs/operators'
import { EbCart } from '../interface/eb-cart.interface'
import { EbOrderEntry, EbQuickOrderEntry } from '../interface/eb-order-entry.interface'
import { EbMultiCartService } from './eb-multi-cart.service'

@Injectable({ providedIn: 'root' })
export class EbActiveCartService extends ActiveCartService {
  constructor(
    protected multiCartService: EbMultiCartService,
    protected userIdService: UserIdService,
    protected winRef: WindowRef
  ) {
    super(multiCartService, userIdService, winRef)
  }

  loadOrMerge(cartId: string, userId: string, previousUserId: string): void {
    if (cartId === OCC_CART_ID_CURRENT) {
      this.multiCartService.loadCart({
        userId,
        cartId: OCC_CART_ID_CURRENT,
        extraData: {
          active: true
        }
      })
    } else if (
      userId !== previousUserId &&
      userId !== OCC_USER_ID_ANONYMOUS &&
      previousUserId !== OCC_USER_ID_ANONYMOUS
    ) {
      // This case covers the case when you are logged in and then asm user logs in and you don't want to merge, but only load emulated user cart
      // Similarly when you are logged in as asm user and you logout and want to resume previous user session
      this.multiCartService.loadCart({
        userId,
        cartId,
        extraData: {
          active: true
        }
      })
    }
  }

  override isGuestCart(cart?: EbCart): Observable<boolean> {
    return of(false)
  }

  getActive(): Observable<EbCart> {
    return this.activeCart$
  }

  addEntriesToCart(entries: EbOrderEntry[]): void {
    combineLatest([this.userIdService.getUserId(), this.getActiveCartId()])
      .pipe(
        filter(([userId, cartId]) => !!(userId && cartId)),
        take(1)
      )
      .subscribe(([userId, cartId]) => {
        const orderEntries = entries.map(value => {
          return {
            product: {
              code: value.product.code
            },
            quantity: 1
          } as EbOrderEntry
        })
        if (orderEntries.length > 0) {
          this.multiCartService.addEntries(userId, cartId, orderEntries)
        }
      })
  }

  addQuickOrderEntries(quickOrderEntries: EbQuickOrderEntry[]): void {
    this.requireLoadedCart()
      .pipe(withLatestFrom(this.userIdService.getUserId()))
      .subscribe(([cartState, userId]) => {
        if (cartState) {
          this.multiCartService.addEntries(
            userId,
            getCartIdByUserId(cartState, userId),
            quickOrderEntries
          )
        }
      })
  }
}
